import { useState } from "react";
import { X, LogIn } from "lucide-react";
import React from "react";
import './styles.css'
import { AuthResponse } from "./utils";


interface LoginDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginSuccess: (response: AuthResponse) => void;
}

export default function LoginDialog({ isOpen, onClose, onLoginSuccess }: LoginDialogProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      setError("Please enter both username and password");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await fetch("https://onextwo-mockopservice-dljma65rcq-ew.a.run.app/auth", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username.trim(),
          password: password,
        }),
      });

      if (response.status === 200) {
        const data: AuthResponse = await response.json();
        setUsername("");
        setPassword("");
        onClose();
        onLoginSuccess(data);
      } else {
        const data = await response.json().catch(() => ({}));
        setError(data.error || "Login failed");
      }
    } catch (error) {
      console.error("Login failed:", error);
      setError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setUsername("");
    setPassword("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <div className="dialog-header">
          <h2 className="text-xl font-bold text-white">Player Login</h2>
          <button
            onClick={handleClose}
            className="dialog-close"
          >
            <X className="icon-md" />
          </button>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <p className="dialog-description">
            Enter your credentials to access your betting account.
          </p>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              placeholder="Enter your username"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder="Enter your password"
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-login w-full space-x-2 shadow-xl"
          >
            <LogIn className="icon-md" />
            <span>{isLoading ? "Signing in..." : "Sign In"}</span>
          </button>
        </form>
      </div>
    </div>
  );
}
